import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";

export const studyProtocolManagementServices = {
  //Protocol Metadata
  addProtocolMetadata,
  updateProtocolMetadataData,
  deleteProtocolMetadataData,
  getProtocolMetadataData,
  softDeleteRestoreStudyProtocol,
  getTotalProtocolMetadata,
};

// Add Protocol
async function addProtocolMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addProtocolMetadata`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Update Protocol
async function updateProtocolMetadataData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateProtocolMetadataData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Soft Delete & Restore Protocol
async function softDeleteRestoreStudyProtocol(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyProtocol`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

async function deleteProtocolMetadataData(id) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteProtocolMetadataData/${id}`,
    headersWithAuthWithoutBody("DELETE", headers)
  );
  const data = await response.json();
  return data;
}

// Get Protocols
async function getProtocolMetadataData(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProtocolMetadataData/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Event Column
async function getTotalProtocolMetadata(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getTotalProtocolMetadata/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getTotalProtocolMetadata/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}